<template>
  <div class="col-12 px-0">
    <!-- Chart of the Day -->
    <h2 class="text-black my-3 mr-2">
      Chart of the Day
    </h2>

    <div class="form-group">
      <label>Upload Chart Image</label>
      <img
        v-if="draft.steps.ephemera.chart_image"
        :src="draft.steps.ephemera.chart_image.url"
        :alt="draft.steps.ephemera.chart_image.name"
        class="d-block mb-2"
        style="max-width: 520px;"
      >
      <FileUpload
        :headers="headers"
        :value="draft.steps.ephemera.chart_image ? [draft.steps.ephemera.chart_image] : []"
        @input="chartPictureUploaded"
        :action="`${url}upload/image`"
        :accept="['image/png', 'image/jpeg']"
      />
        <!--

        <div v-else>
          <icon
            icon="add-image"
            class="m-0"
          />
          <div class="el-upload__text">
            Drop your file here or <em>Browse</em>
          </div>
        </div>
      </el-upload> -->
    </div>

    <form-control
      v-model="draft.steps.ephemera.chart_title"
      :no-margin="true"
      title="Chart title"
      placeholder="Enter Chart Title"
      class="mb-3"
      @input="update('chart_title')"
    />

    <div class="form-group">
      <label>Chart Source/Notes</label>

      <HtmlEditor
        v-model="draft.steps.ephemera.chart_source"
        @input="update('chart_source')"
        :token="`Bearer ${$login.getToken()}`"
        :image-upload-url="imageUploadUrl"
        :file-upload-url="fileUploadUrl"
      />
    </div>

    <div class="form-group border-bottom pb-5 mb-3">
      <label>Related Article</label>
      <autocomplete-article
        :original-title="draft.steps.ephemera.chart_article ? draft.steps.ephemera.chart_article.title : ''"
        @input="selectedArticle"
      />
    </div>

    <!-- Watching Brief -->
    <WatchingBriefSection v-model="draft.steps.ephemera.watching_brief" />

    <!-- In Case You Missed It -->
    <InCaseYouMissedItSection v-model="draft.steps.ephemera.audios" />

    <!-- Tellimer Events -->
    <TellimerEventsSection v-model="draft.steps.ephemera.events" />
  </div>
</template>

<script>
import {HtmlEditor, FileUpload} from '@frontend/components'
import AutocompleteArticle from '@/components/AutocompleteArticle'

import InCaseYouMissedItSection from '../Components/InCaseYouMissedItSection'
import TellimerEventsSection from '../Components/TellimerEventsSection'
import WatchingBriefSection from '../Components/WatchingBriefSection'

export default {
  name: 'TellimerTodayEphemeraStep',

  components: {
    AutocompleteArticle,
    InCaseYouMissedItSection,
    TellimerEventsSection,
    WatchingBriefSection,
    FileUpload,
    HtmlEditor,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    highlightFields: {
      required: true,
      type: Boolean,
    },
  },

  data () {
    const chartPictures = []

    /* eslint-disable camelcase */
    const {chart_image} = this.draft.steps.ephemera

    if (chart_image) {
      chartPictures[0] = chart_image
    }
    /* eslint-enable */

    return {
      error: null,
      chartPictures,
      url: process.env.VUE_APP_API_ENDPOINT,
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
    }
  },

  beforeMount () {
    this.draft.steps.ephemera.audios = this.draft.steps.ephemera.audios || [{title: '', source: '', link: ''}]
    this.draft.steps.ephemera.events = this.draft.steps.ephemera.events || [{date: '', description: '', link: ''}]
    
    this.draft.steps.ephemera.watching_brief = this.draft.steps.ephemera.watching_brief || { link: '', source: '', image: null }
  },

  computed: {
    headers () {
      return {
        Authorization: 'Bearer ' + this.$login.getToken(),
      }
    },
  },

  methods: {
    update (key = '') {
      this.$emit(
          'update',
          {
            steps: {
              ephemera: {
                [key]: this.draft.steps.ephemera[key],
              },
            },
          }
      )
    },

    selectedArticle (article) {
      if (article) {
        const {id, slug, title, analyst} = article
        const data = {
          id,
          slug,
          title,
          analyst,
        }

        this.draft.steps.ephemera.chart_article = data
        this.update('chart_article')
      }
    },

    chartPictureUploaded (fileList) {
      const img = fileList[0]

      this.draft.steps.ephemera.chart_image = img
      this.update('chart_image')

    },

    chartPictureRemoved () {
      this.chartPictures = []
      this.draft.steps.ephemera.chart_image = null
      this.update('chart_image')
    },

  },
}
</script>

